(() => {
  'use strict';
  const section = document.querySelector('#zx-habitats');
  const invite = section?.querySelector('#v4-habitat-invite');
  const panel = section?.querySelector('#v4-habitat-panel');
  const studio = section?.querySelector('#zx-studio');
  if (!section || !invite || !panel || !studio || !window.SetupUI) return;

  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const toggle = invite.querySelector('[data-v4-habitat-toggle]');
  const status = section.querySelector('[data-v4-habitat-status]');
  let animals = window.ZDATA?.products || [];
  const plannerHashes = new Set(['#zx-habitats', '#zx-studio', '#v4-habitat-panel', '#v4-planner-title', '#v3-habitat-title', '#v3-setup-step-0', '#v3-setup-step-1', '#v3-setup-step-2']);
  let opened = false;

  const setupState = () => window.SetupUI.getState();
  const currentAnimal = () => animals.find(p => String(p.id) === String(setupState().id));
  const scrollTo = node => node?.scrollIntoView({behavior:reduced.matches ? 'auto' : 'smooth', block:'start'});
  function changeHash(hash, replace = false) {
    if (location.hash === hash) return;
    try { history[replace ? 'replaceState' : 'pushState'](history.state, '', hash); }
    catch (_) { /* File previews can restrict history. The disclosure still works. */ }
  }
  function emit(source) {
    const {id, vi} = setupState();
    document.dispatchEvent(new CustomEvent('z:habitat', {bubbles:true, detail:{open:opened, source, id, vi}}));
  }
  function sync() {
    animals=window.ZDATA?.products||[];const p = currentAnimal();
    const chosen = invite.querySelector('[data-v4-habitat-selection]');
    const image = chosen.querySelector('img');
    chosen.hidden = !p;
    if (p) {
      const variant=p.variants?.[setupState().vi],source=variant?.image?(variant.imageFull||variant.image):(p.imageFull||p.image),focal=variant?.image?variant.imageFocalPoint:p.imageFocalPoint;
      image.hidden=!source;
      if(source){if(image.getAttribute('src')!==source){image.removeAttribute('srcset');image.removeAttribute('sizes');image.src=source;}image.style.objectPosition=focal||'50% 50%';}
      else{image.removeAttribute('src');image.removeAttribute('srcset');image.removeAttribute('sizes');}
      invite.querySelector('[data-v4-habitat-selected-name]').textContent = p.name;
    } else {
      image.removeAttribute('src');image.removeAttribute('srcset');image.removeAttribute('sizes');
      invite.querySelector('[data-v4-habitat-selected-name]').textContent = '';
    }
    invite.querySelector('[data-v4-habitat-action-label]').textContent = opened ? 'Close habitat planner' : p ? 'Continue your habitat' : 'Build a habitat';
    document.querySelectorAll('[data-v4-habitat-toggle],a[href="#zx-habitats"],a[href="#zx-studio"]').forEach(n => {
      n.setAttribute('aria-expanded', String(opened));
      n.setAttribute('aria-controls', 'v4-habitat-panel');
    });
    section.classList.toggle('v4-planner-is-open', opened);
  }
  function open({source = 'api', focus = true, scroll = true, hash = true, notify = true, step} = {}) {
    const changed = !opened;
    opened = true;
    panel.hidden = false;
    panel.removeAttribute('inert');
    if (Number.isInteger(step) && step >= 0 && step <= 2) SetupUI.setStep(step, false);
    sync();
    if (hash) changeHash('#zx-studio');
    if (scroll) scrollTo(panel);
    if (focus) section.querySelector('#v4-planner-title')?.focus({preventScroll:true});
    if (changed && notify) { status.textContent = 'Habitat planner opened. Your choices stay here when you close it.'; emit(source); }
  }
  function close({source = 'api', focus = true, scroll = true, hash = true} = {}) {
    if (!opened) return;
    opened = false;
    // Return focus before hiding the region that may contain the active control.
    if (focus) toggle.focus({preventScroll:true});
    panel.hidden = true;
    panel.setAttribute('inert', '');
    sync();
    if (hash && plannerHashes.has(location.hash)) changeHash('#v4-habitat-invite', true);
    if (scroll) scrollTo(invite);
    status.textContent = 'Habitat planner closed. Your choices are still here.';
    emit(source);
  }

  section.addEventListener('click', event => {
    if (event.target.closest('[data-v4-habitat-toggle]')) {
      event.preventDefault();
      if (opened) close({source:'invitation'}); else open({source:'invitation'});
    } else if (event.target.closest('[data-v4-habitat-close]')) {
      event.preventDefault(); close({source:'close-button'});
    } else if (event.target.closest('[data-v4-habitat-reset]')) {
      // Quick reset from the invite strip, so a plan can be cleared without
      // opening the planner. Keep focus here rather than jumping into the panel.
      event.preventDefault();
      window.SetupUI.reset?.({focus:false});
      sync();
      status.textContent = 'Habitat plan cleared. Your saved fellas and bag are still there.';
      toggle.focus({preventScroll:true});
    }
  });
  document.addEventListener('click', event => {
    const link = event.target.closest('a[href]');
    if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    let url;
    try { url = new URL(link.href, location.href); } catch (_) { return; }
    if (url.origin !== location.origin || url.pathname !== location.pathname || url.search !== location.search || !plannerHashes.has(url.hash)) return;
    event.preventDefault();
    const match = url.hash.match(/^#v3-setup-step-([012])$/);
    open({source:'navigation', step:match ? Number(match[1]) : undefined});
  });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape' || event.defaultPrevented || !opened || !panel.contains(document.activeElement) || document.querySelector('dialog[open]')) return;
    if (event.target.closest('select')) return;
    event.preventDefault(); close({source:'escape'});
  });

  // Capture reveals the panel before habitat.js handles the existing z:plan event.
  // That original listener remains responsible for the exact animal and variant.
  document.addEventListener('z:plan', event => {
    if (setupState().pending || !animals.some(p => String(p.id) === String(event.detail?.id))) return;
    open({source:'animal-plan', focus:false, scroll:false, notify:false});
  }, true);
  document.addEventListener('z:plan', event => {
    if (setupState().pending || !animals.some(p => String(p.id) === String(event.detail?.id))) return;
    // Selection is ready now. Frame the whole planner so its heading and close
    // control stay visible when the introductory copy wraps on narrow screens.
    open({source:'animal-plan', notify:false}); emit('animal-plan');
  });
  document.addEventListener('z:catalog',sync);document.addEventListener('z:product',sync);
  document.addEventListener('z:state', event => {
    if (event.detail?.reason === 'checklist') sync();
  });
  studio.addEventListener('click', () => queueMicrotask(sync));
  studio.addEventListener('change', () => queueMicrotask(sync));

  function followHash({initial = false} = {}) {
    const hash = location.hash;
    if (plannerHashes.has(hash)) {
      const match = hash.match(/^#v3-setup-step-([012])$/);
      open({source:initial ? 'deep-link' : 'history', focus:!initial, hash:false, step:match ? Number(match[1]) : undefined});
    } else if (opened) close({source:'history', focus:false, scroll:false, hash:false});
  }
  window.addEventListener('hashchange', () => followHash());
  window.HabitatInviteUI = {open, close, getState:() => ({open:opened, id:setupState().id, vi:setupState().vi})};
  sync();
  if (plannerHashes.has(location.hash)) requestAnimationFrame(() => followHash({initial:true}));
})();
